export const appsCatalogsUsage = "/apps/catalogs_usage";
